import { TokenIcon } from './holdings-table'
import { CORE_TOKEN_LOGOS, SOL_MINT, USDC_MINT, USDT_MINT } from '@/lib/default-tokens'

const CORE: { mint: string; symbol: string }[] = [
  { mint: SOL_MINT, symbol: 'SOL' },
  { mint: USDC_MINT, symbol: 'USDC' },
  { mint: USDT_MINT, symbol: 'USDT' },
]

/**
 * Logo-and-ticker chips for the tokens the trading wallet holds (John's
 * rule, Oct 29 2026: logos and tickers, never the full words). Display
 * only; the pickers and swap chips stay interactive on their own.
 */
export function CoreAssetChips({ size = 'size-4', logosOnly = false, className = '' }: { size?: string; logosOnly?: boolean; className?: string }) {
  return (
    <span className={`inline-flex flex-wrap items-center gap-1.5 align-middle ${className}`}>
      {CORE.map((asset) => (
        <AssetChip key={asset.mint} symbol={asset.symbol} imageUrl={CORE_TOKEN_LOGOS[asset.mint]} size={size} logoOnly={logosOnly} />
      ))}
    </span>
  )
}

export function AssetChip({ symbol, imageUrl, size = 'size-4', logoOnly = false }: { symbol: string; imageUrl?: string; size?: string; logoOnly?: boolean }) {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-surface-2 py-0.5 pl-0.5 pr-2 text-xs font-semibold text-text" title={symbol} aria-label={symbol}>
      <TokenIcon symbol={symbol} imageUrl={imageUrl} size={size} />
      {logoOnly ? null : symbol}
    </span>
  )
}
